import { defineMessages } from 'react-intl';

const messages = defineMessages({
  showAllAddOns: {
    description: 'link to show all add-ons',
    defaultMessage: 'Show all Add-Ons',
    id: '0rCBkF',
  },
  noAddOnsYet: {
    description: 'no add-ons yet message',
    defaultMessage: 'No Add-Ons activated yet!',
    id: 'rYiEAO',
  },
  addOnsDescription: {
    description: 'description of what add-ons do in ShipStation',
    defaultMessage: "Add-Ons extend ShipStation's capabilities to accommodate specialized workflows.",
    id: '6UIUnn',
  },
  addOns: {
    description: 'add-ons card title',
    defaultMessage: 'Add-Ons',
    id: '6HKzHU',
  },
  seeAllAddOns: {
    description: 'premium features card description',
    defaultMessage: 'See all active and available add-ons in the <link>Add-Ons settings</link>',
    id: 'q5jObh',
  },
  emptyBox: {
    description: 'empty box svg alt text',
    defaultMessage: 'empty box',
    id: 'wmCwrR',
  },
});

export default messages;
